


















import { Vue, Component, Prop } from "vue-property-decorator";

// EnumsData
import {
  ContractProductsKinds,
  ContractProductsTypes
} from "@/data/enums/contractProducts";

// Types
import { IClient } from "@/models/clients";
import { Location } from "vue-router";

@Component({
  components: {
    "used-contract-categories": () =>
      import(
        "@/components/app/global/contractCategories/usedContractCategories.vue"
      )
  }
})
export default class AdminClientCProdsProducts extends Vue {
  // Props

  @Prop({ required: true })
  public clientId!: IClient["id"];

  @Prop({ required: true })
  public cpType!: ContractProductsTypes;

  @Prop({ required: true })
  public cpKind!: ContractProductsKinds;

  @Prop({ required: true })
  public routeName!: Location["name"];

  @Prop({ default: null })
  public goBackRoute!: Location;

  // Variables

  public showCategoriesFilter = false;
}
